/* eslint-disable indent */
import React from "react";
import toast from "react-hot-toast";
import styles from "../stylesER.module.scss";

export const AsesoriaExternaModal = ({
  isOpen,
  monthIndex,
  currentYear,
  meses,
  asesoriaUsd,
  setAsesoriaUsd,
  asesoriaFecha,
  setAsesoriaFecha,
  asesoriaPreviewLocal,
  setAsesoriaPreviewLocal,
  getDolarValue,
  guardarCostoFijo,
  formatCurrency,
  localString,
  pais,
  onClose,
  onSaved,
}) => {
  if (!isOpen || monthIndex === null) return null;

  const handleSave = async () => {
    if (asesoriaUsd <= 0) {
      toast.error("Ingresa un monto USD mayor a 0");
      return;
    }
    if (!asesoriaFecha) {
      toast.error("Selecciona una fecha");
      return;
    }
    const dolarUsado = getDolarValue(asesoriaFecha);
    const localCalculado = Math.round(asesoriaUsd * dolarUsado);
    await guardarCostoFijo(monthIndex, "asesoria_externa", localCalculado, asesoriaUsd, asesoriaFecha);
    onSaved();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={`${styles.modalContent} ${styles.editCostModal}`} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>
          Editar Asesoría externa - {meses[monthIndex]} {currentYear}
        </h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "20px",
            marginBottom: "20px",
            alignItems: "end",
          }}
        >
          {/* Fecha factura */}
          <div>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "0.95rem" }}>
              Fecha factura
            </label>
            <input
              type="date"
              value={asesoriaFecha}
              onChange={(e) => {
                const nuevaFecha = e.target.value;
                setAsesoriaFecha(nuevaFecha);
                if (asesoriaUsd > 0 && nuevaFecha) {
                  const dolar = getDolarValue(nuevaFecha);
                  setAsesoriaPreviewLocal(Math.round(asesoriaUsd * dolar));
                }
              }}
              max={new Date(currentYear, monthIndex + 1, 0).toISOString().split("T")[0]}
              style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
            />
          </div>

          {/* Monto en USD */}
          <div>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "0.95rem" }}>
              Monto en USD
            </label>
            <div style={{ position: "relative" }}>
              <span
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#666",
                  fontWeight: "600",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              >
                US$
              </span>
              <input
                type="number"
                value={asesoriaUsd || ""}
                onChange={(e) => {
                  const usd = parseFloat(e.target.value) || 0;
                  setAsesoriaUsd(usd);
                  if (asesoriaFecha) {
                    const dolar = getDolarValue(asesoriaFecha);
                    setAsesoriaPreviewLocal(Math.round(usd * dolar));
                  }
                }}
                min="0"
                placeholder="0.00"
                style={{
                  width: "100%",
                  padding: "10px 10px 10px 50px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  textAlign: "right",
                  fontWeight: "600",
                  MozAppearance: "textfield",
                  WebkitAppearance: "textfield",
                  appearance: "textfield",
                }}
                onWheel={(e) => e.preventDefault()}
              />
            </div>
          </div>

          {/* Preview local */}
          <div>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "0.95rem" }}>
              Valor en moneda local (preview)
            </label>
            <div
              style={{
                padding: "10px 12px",
                backgroundColor: "#f5f5f5",
                borderRadius: "6px",
                fontWeight: "700",
                fontSize: "1.1rem",
                textAlign: "right",
                border: "1px solid #ddd",
              }}
            >
              {formatCurrency(asesoriaPreviewLocal)}
            </div>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            color: "#666",
            fontSize: "0.9rem",
            margin: "10px 0 20px",
            padding: "8px",
            backgroundColor: "#f8f9fa",
            borderRadius: "6px",
          }}
        >
          Cotización del dólar usada:{" "}
          {asesoriaFecha
            ? getDolarValue(asesoriaFecha).toLocaleString(localString(pais), {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "-"}
        </div>

        <div className={styles.modalActions}>
          <button className={styles.btnSave} onClick={handleSave}>
            Guardar
          </button>
          <button className={styles.btnCancel} onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};
